// A view file gone after a deploy (an old tab asking for the old file name) reloads the page
// once; another failure within 10 s shows the error page instead of looping (OQ-179,
// platform-docs/ui/app-views.md § Loading the views after a deploy).
const KEY = 'staleChunkReloadAt';
const WINDOW_MS = 10_000;

type ReloadWindow = Pick<Window, 'addEventListener' | 'sessionStorage'> & { location: Pick<Location, 'reload'> };

export const reloadOnStaleChunk = (win: ReloadWindow, now: () => number = Date.now) => {
  win.addEventListener('vite:preloadError', (event) => {
    let last = 0;
    try {
      last = Number(win.sessionStorage.getItem(KEY)) || 0;
    } catch {
      // No storage: reload anyway.
    }
    if (now() - last < WINDOW_MS) return;
    try {
      win.sessionStorage.setItem(KEY, String(now()));
    } catch {
      // No storage: reload anyway.
    }
    event.preventDefault();
    win.location.reload();
  });
};
